<script setup lang="ts">

defineOptions({
  name: 'ListTaskInfo',
})

</script>

<template>
  <div class="list-task-info">
    <slot />
  </div>
</template>

<style lang="scss" scoped src="./ListTaskInfo.scss" />
